import { Box, Button, Container, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { lang } from 'src/utils';

/* Temporary page until design confirmed */
export const NotFoundPage = () => {
  return (
    <Container
      maxWidth="md"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}>
      <Box>
        <Typography variant="h1" gutterBottom>
          {lang.pageNotFound}
        </Typography>
        <Typography gutterBottom>{lang.pageDoesNotExist}</Typography>
        <Button variant="contained" component={Link} to="/">
          {lang.backHome}
        </Button>
      </Box>
    </Container>
  );
};
